import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchWithAuthBaseQuery } from '../api.helpers';

import { validateAndTransformResponse } from './helpers';
import { surgeonsResponseSchema, type SurgeonsResponse } from './schemas';

import type { CCSurgeon } from '#entities';
import type { DataWithValidation } from './types';

const paths = {
  surgeons: 'api/surgeons',
} as const;

export const surgeonsApi = createApi({
  reducerPath: 'surgeonsApi',

  baseQuery: fetchWithAuthBaseQuery,
  refetchOnReconnect: true,
  endpoints: build => ({
    getSurgeons: build.query<DataWithValidation<CCSurgeon[]>, void>({
      query: () => paths.surgeons,
      transformResponse: (response: SurgeonsResponse) =>
        validateAndTransformResponse(
          surgeonsResponseSchema,
          response,
          value => value?.id,
          'surgeons',
        ),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetSurgeonsQuery } = surgeonsApi;
